// Utilitários para persistência das configurações do customizer
const CUSTOMIZER_STORAGE_KEY = 'jklweb_customizer_settings';

export interface CustomizerSettings {
  activeDir: string;
  activeMode: string;
  activeTheme: string;
  isCollapse: boolean;
  isLayout: string;
  isLanguage: string;
  isCardShadow: boolean;
  borderRadius: number;
}

// Salvar configurações no localStorage
export const saveCustomizerSettings = (settings: Partial<CustomizerSettings>): void => {
  try {
    if (typeof window !== 'undefined') {
      const currentSettings = loadCustomizerSettings();
      const updatedSettings = { ...currentSettings, ...settings };
      localStorage.setItem(CUSTOMIZER_STORAGE_KEY, JSON.stringify(updatedSettings));
    }
  } catch (error) {
    console.warn('Erro ao salvar configurações do customizer:', error);
  }
};

// Carregar configurações do localStorage
export const loadCustomizerSettings = (): Partial<CustomizerSettings> => {
  try {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(CUSTOMIZER_STORAGE_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
    }
  } catch (error) {
    console.warn('Erro ao carregar configurações do customizer:', error);
  }
  return {};
};

// Limpar configurações do localStorage
export const clearCustomizerSettings = (): void => {
  try {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(CUSTOMIZER_STORAGE_KEY);
    }
  } catch (error) {
    console.warn('Erro ao limpar configurações do customizer:', error);
  }
};

// Verificar se é ambiente browser
export const isBrowser = (): boolean => {
  return typeof window !== 'undefined';
};